/* global $ */

(function (scope) {
  "use strict";

  /**
   *
   */
  var PrintModalGiveUsACallView = (scope.PrintModalGiveUsACallView = function (
    controller,
    design,
    printIframePageUrl
  ) {
    this.controller = controller;
    this.design = design;

    this.thresholdGiveUsACall = 1500.0;
    this.delayDisplay = 10000;
    this.isShown = false;
    this.timer = null;

    this.$el = $("#PrintModalGiveUsACallView");

    // this.$el.on('click', '.modal-background' , this.hideModal.bind(this));
    this.$el.on("click", ".modal-back", this.back.bind(this));
  });

  /**
   * Hide modal review
   * @public
   */
  PrintModalGiveUsACallView.prototype.hideModal = function (e) {
    this.$el.hide();
  };

  /**
   * Show the modal of review if the total is above the threshold
   */
  PrintModalGiveUsACallView.prototype.activeModal = function (total) {
    // total is formated as 12.68 = 1268
    // thresholdGiveUsACall need to be formated as well
    // the total needs to be above the threshold
    // AND the user did see the modal yet
    if (
      total >= this.thresholdGiveUsACall * 100 &&
      !this.isShown &&
      this.controller.error == null
    ) {
      // clear the timer in case we active the modal multiple time during the 10s gap
      window.clearTimeout(this.timer);
      this.timer = window.setTimeout(
        function () {
          this.showModal();
        }.bind(this),
        this.delayDisplay
      );
    } else {
      window.clearTimeout(this.timer);
    }
  };

  /**
   * Show the modal
   */
  PrintModalGiveUsACallView.prototype.showModal = function () {
    this.$el.fadeIn(400, "linear");
    this.isShown = true;
  };

  /**
   * Hide modal tool
   * @private
   */
  PrintModalGiveUsACallView.prototype.back = function (e) {
    this.hideModal(e);
  };
})((window.sculpteo = window.sculpteo || {}));
